module.exports = __webpack_public_path__ + "img/klcx_10.58d69b93.jpg";